import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getStoreDetail, updateStore } from "../../redux/actions/storeActions";
import DefaultLayout from "../../layouts/DefaultLayout";
import { toast } from "react-toastify";
import { getListStoresUsers } from "../../redux/actions/userActions";
import GooglePlacesAutocomplete from "react-google-autocomplete";
import {
  API_MAP_KEY,
  PLACES_AUTOCOMPLETE_OPTIONS,
  applyGeocodedPlace,
  geocodeAddress,
} from "../../utils/googleMaps";
// import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

// Imports pour react-leaflet
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Configuration de l'icône par défaut de leaflet (pour éviter les problèmes d'affichage)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

// Composant pour gérer les clics sur la carte dans le modal manuel
function ClickableMap({ manualLat, manualLng, setManualLat, setManualLng }) {
  useMapEvents({
    click(e) {
      setManualLat(e.latlng.lat);
      setManualLng(e.latlng.lng);
    },
  });
  return (
    <Marker position={[manualLat, manualLng]}>
      <Popup>Position actuelle</Popup>
    </Marker>
  );
}

function EditStoreScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  let { id } = useParams();

  // None, Exist, New User
  const [userType, setUserType] = useState("None");

  const [selectUser, setSelectUser] = useState("");
  const [selectUserError, setSelectUserError] = useState("");

  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFirstNameError] = useState("");

  const [lastName, setLastName] = useState("");
  const [lastNameError, setLastNameError] = useState("");

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [passwordConfirmError, setPasswordConfirmError] = useState("");

  const [storeName, setStoreName] = useState("");
  const [storeNameError, setStoreNameError] = useState("");

  const [storeLogoValue, setStoreLogoValue] = useState("");
  const [storeLogo, setStoreLogo] = useState("");
  const [storeLogoError, setStoreLogoError] = useState("");

  const [storeCoverValue, setStoreCoverValue] = useState("");
  const [storeCover, setStoreCover] = useState("");
  const [storeCoverError, setStoreCoverError] = useState("");

  const [storeType, setStoreType] = useState("");
  const [storeTypeError, setStoreTypeError] = useState("");

  const [storeDescription, setStoreDescription] = useState("");
  const [storeDescriptionError, setStoreDescriptionError] = useState("");

  const [storeAddress, setStoreAddress] = useState("");
  const [storeAddressError, setStoreAddressError] = useState("");

  const [locationX, setLocationX] = useState(0);
  const [locationXError, setLocationXError] = useState("");

  const [locationY, setLocationY] = useState(0);
  const [locationYError, setLocationYError] = useState("");

  const [storeTime, setStoreTime] = useState("");
  const [storeTimeError, setStoreTimeError] = useState("");

  const [storePhone, setStorePhone] = useState("");
  const [storePhoneError, setStorePhoneError] = useState("");

  const [storeEmail, setStoreEmail] = useState("");
  const [storeEmailError, setStoreEmailError] = useState("");

  const [deliveryPrice, setDeliveryPrice] = useState("");
  const [deliveryPriceError, setDeliveryPriceError] = useState("");

  // ----------------- Etats pour le modal de saisie manuelle -----------------
  const [showManualModal, setShowManualModal] = useState(false);
  const [manualAddress, setManualAddress] = useState("");
  const [manualAddressError, setManualAddressError] = useState("");
  const [manualLat, setManualLat] = useState(0);
  const [manualLng, setManualLng] = useState(0);

  // ----------------- Récupération des données utilisateurs -----------------

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const storeDetail = useSelector((state) => state.detailStore);
  const { loadingStoreInfo, errorStoreInfo, successStoreInfo, storeInfo } =
    storeDetail;

  const storeUpdate = useSelector((state) => state.updateStore);
  const { loadingStoreUpdate, errorStoreUpdate, successStoreUpdate } =
    storeUpdate;

  // usersListStoresUser
  const listUsersStores = useSelector((state) => state.usersListStoresUser);
  const { listStoresUser, loadingListStoresUser, errorListStoresUser, pages } =
    listUsersStores;

  const redirect = "/";

  useEffect(() => {
    const fetchData = async () => {
      if (!userInfo) {
        navigate(redirect);
      } else {
        await dispatch(getListStoresUsers("0"));
        await dispatch(getStoreDetail(id));
      }
    };

    fetchData();
  }, [navigate, userInfo, dispatch, id]);

  useEffect(() => {
    if (storeInfo && storeInfo !== null && storeInfo !== undefined) {
      if (storeInfo.user?.id) {
        const selectedUser = listStoresUser?.find(
          (user) => user.id === Number(storeInfo.user?.id)
        );

        if (selectedUser) {
          setUserType("Exist");
          setSelectUser(storeInfo.user?.id ?? "");
        } else {
          setUserType("None");
          setSelectUser("");
        }
      }
      setStoreName(storeInfo.store_name ?? "");
      setStoreType(storeInfo.store_type ?? "");
      setStoreDescription(storeInfo.store_description ?? "");
      setStoreTime(storeInfo.preparing_time ?? "");
      setStoreEmail(storeInfo.store_email ?? "");
      setStorePhone(storeInfo.store_phone ?? "");
      setStoreAddress(storeInfo.store_address ?? "");
      setLocationX(storeInfo.location_x ?? "");
      setLocationY(storeInfo.location_y ?? "");
      setDeliveryPrice(storeInfo.delivery_price ?? "");
    }
  }, [storeInfo]);

  useEffect(() => {
    if (successStoreUpdate) {
      dispatch(getStoreDetail(id));
    }
  }, [successStoreUpdate, dispatch]);

  // ----------------- Get user's current location -----------------
  // useEffect(() => {
  //   if ("geolocation" in navigator) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const { latitude, longitude } = position.coords;
  //         setLocationX(latitude);
  //         setLocationY(longitude);
  //         // Also update manual modal defaults
  //         setManualLat(latitude);
  //         setManualLng(longitude);
  //       },
  //       (error) => {
  //         console.error("Error obtaining location:", error);
  //       }
  //     );
  //   }
  // }, []);

  // No longer needed as we're using inline styles
  // const mapContainerStyle = {
  //   width: "100%",
  //   height: "300px",
  // };

  return (
    <DefaultLayout>
      <div>
        {/* Modern Breadcrumb */}
        <nav className="flex mb-6" aria-label="Breadcrumb">
          <ol className="inline-flex items-center space-x-1 md:space-x-3">
            <li className="inline-flex items-center">
              <a
                href="/dashboard"
                className="inline-flex items-center text-sm font-medium text-primary hover:text-secondary transition-colors duration-200"
              >
                <svg
                  className="w-4 h-4 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                  ></path>
                </svg>
                Dashboard
              </a>
            </li>
            <li>
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 text-secondary"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <a
                  href="/stores"
                  className="ml-1 text-sm font-medium text-primary hover:text-secondary md:ml-2 transition-colors duration-200"
                >
                  Stores
                </a>
              </div>
            </li>
            <li aria-current="page">
              <div className="flex items-center">
                <svg
                  className="w-5 h-5 text-secondary"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <span className="ml-1 text-sm font-medium text-secondary md:ml-2">
                  Edit Store
                </span>
              </div>
            </li>
          </ol>
        </nav>

        {/* Header with Store Image */}
        <div
          className="relative mb-8 rounded-xl overflow-hidden bg-gradient-to-r from-primary to-secondary shadow-lg"
          style={{
            backgroundImage: "url('/assets/background-auth-screen.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-primary/80 to-secondary/80"></div>
          <div className="relative z-10 px-6 py-8 md:px-10 md:py-12">
            <h1 className="text-2xl md:text-3xl font-bold text-white mb-2">
              Edit Store
            </h1>
            <p className="text-white/80 max-w-xl">
              Edit a restaurant or grocery store with all the necessary details
              for your customers.
            </p>
          </div>
        </div>

        {/* Main Form Container */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-8">
          <div className="px-6 py-5 border-b border-primary/10">
            <h2 className="font-semibold text-primary">Store Information</h2>
            <p className="text-sm text-secondary mt-1">
              Fill in the details to create a new store
            </p>
          </div>
          <div className="p-6">
            {/* User Type Selection */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-primary mb-2">
                Store Owner <span className="text-red-500">*</span>
              </label>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <div
                  className={`border rounded-lg p-4 cursor-pointer transition-all duration-200 ${
                    userType === "None"
                      ? "border-primary bg-primary/5"
                      : "border-primary/20 hover:border-primary/50"
                  }`}
                  onClick={() => setUserType("None")}
                >
                  <div className="flex items-center mb-2">
                    <div
                      className={`w-4 h-4 rounded-full mr-2 ${
                        userType === "None"
                          ? "bg-primary"
                          : "border border-primary/40"
                      }`}
                    ></div>
                    <span className="font-medium">No Owner</span>
                  </div>
                  <p className="text-xs text-primary/60">
                    Create store without assigning an owner
                  </p>
                </div>

                <div
                  className={`border rounded-lg p-4 cursor-pointer transition-all duration-200 ${
                    userType === "Exist"
                      ? "border-primary bg-primary/5"
                      : "border-primary/20 hover:border-primary/50"
                  }`}
                  onClick={() => setUserType("Exist")}
                >
                  <div className="flex items-center mb-2">
                    <div
                      className={`w-4 h-4 rounded-full mr-2 ${
                        userType === "Exist"
                          ? "bg-primary"
                          : "border border-primary/40"
                      }`}
                    ></div>
                    <span className="font-medium">Existing User</span>
                  </div>
                  <p className="text-xs text-primary/60">
                    Assign store to an existing user
                  </p>
                </div>

                <div
                  className={`border rounded-lg p-4 cursor-pointer transition-all duration-200 ${
                    userType === "New User"
                      ? "border-primary bg-primary/5"
                      : "border-primary/20 hover:border-primary/50"
                  }`}
                  onClick={() => setUserType("New User")}
                >
                  <div className="flex items-center mb-2">
                    <div
                      className={`w-4 h-4 rounded-full mr-2 ${
                        userType === "New User"
                          ? "bg-primary"
                          : "border border-primary/40"
                      }`}
                    ></div>
                    <span className="font-medium">New User</span>
                  </div>
                  <p className="text-xs text-primary/60">
                    Create a new user as the store owner
                  </p>
                </div>
              </div>
            </div>
            {/*  */}
            {userType === "New User" && (
              <div className="bg-gray-50 rounded-lg p-6 mb-8 border border-primary/10">
                <h3 className="text-lg font-medium text-primary mb-4">
                  Create New User
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-primary mb-2">
                      First Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter first name"
                      className={`w-full px-4 py-3 rounded-md border ${
                        firstNameError
                          ? "border-red-500 bg-red-50"
                          : "border-primary/20"
                      } focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm`}
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                    {firstNameError && (
                      <p className="mt-1 text-xs text-red-500">
                        {firstNameError}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-primary mb-2">
                      Last Name
                    </label>
                    <input
                      type="text"
                      placeholder="Enter last name"
                      className={`w-full px-4 py-3 rounded-md border ${
                        lastNameError
                          ? "border-red-500 bg-red-50"
                          : "border-primary/20"
                      } focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm`}
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                    {lastNameError && (
                      <p className="mt-1 text-xs text-red-500">
                        {lastNameError}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Email <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                        </svg>
                      </div>
                      <input
                        type="email"
                        placeholder="Enter email address"
                        className={`w-full pl-10 pr-4 py-3 rounded-lg border ${
                          emailError ? "border-red-500 bg-red-50" : "border-gray-300 focus:border-primary"
                        } focus:outline-none transition-colors`}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    {emailError && (
                      <p className="mt-1 text-xs text-red-500 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {emailError}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Phone <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                        </svg>
                      </div>
                      <input
                        type="text"
                        placeholder="Enter phone number"
                        className={`w-full pl-10 pr-4 py-3 rounded-lg border ${
                          phoneError ? "border-red-500 bg-red-50" : "border-gray-300 focus:border-primary"
                        } focus:outline-none transition-colors`}
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                      />
                    </div>
                    {phoneError && (
                      <p className="mt-1 text-xs text-red-500 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {phoneError}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Password <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <input
                        type="password"
                        placeholder="Enter password"
                        className={`w-full pl-10 pr-4 py-3 rounded-lg border ${
                          passwordError ? "border-red-500 bg-red-50" : "border-gray-300 focus:border-primary"
                        } focus:outline-none transition-colors`}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
                    {passwordError && (
                      <p className="mt-1 text-xs text-red-500 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {passwordError}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Confirm Password <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                        </svg>
                      </div>
                      <input
                        type="password"
                        placeholder="Confirm password"
                        className={`w-full pl-10 pr-4 py-3 rounded-lg border ${
                          passwordConfirmError ? "border-red-500 bg-red-50" : "border-gray-300 focus:border-primary"
                        } focus:outline-none transition-colors`}
                        value={passwordConfirm}
                        onChange={(e) => setPasswordConfirm(e.target.value)}
                      />
                    </div>
                    {passwordConfirmError && (
                      <p className="mt-1 text-xs text-red-500 flex items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-1" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        {passwordConfirmError}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            )}

            {userType === "Exist" && (
              <div className="bg-gray-50 rounded-lg p-6 mb-8 border border-primary/10">
                <h3 className="text-lg font-medium text-primary mb-4">
                  Select Existing User
                </h3>
                <div>
                  <label className="block text-sm font-medium text-primary mb-2">
                    Store Owner <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`w-full px-4 py-3 rounded-md border appearance-none bg-white pr-10 ${
                        selectUserError
                          ? "border-red-500 bg-red-50"
                          : "border-primary/20"
                      } focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm`}
                      value={selectUser}
                      onChange={(e) => setSelectUser(e.target.value)}
                    >
                      <option value="">Select a user</option>
                      {listStoresUser?.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.full_name}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-primary/60">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                  {selectUserError && (
                    <p className="mt-1 text-xs text-red-500">
                      {selectUserError}
                    </p>
                  )}
                  <p className="mt-2 text-xs text-primary/60">
                    This user will have full access to manage this store
                  </p>
                </div>
              </div>
            )}

            {/* Store Information Section */}
            <div className="mb-8">
              <h3 className="text-lg font-medium text-primary mb-6">
                Store Details
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-medium text-primary mb-2">
                    Store Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter store name"
                    className={`w-full px-4 py-3 rounded-md border ${
                      storeNameError
                        ? "border-red-500 bg-red-50"
                        : "border-primary/20"
                    } focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm`}
                    value={storeName}
                    onChange={(e) => setStoreName(e.target.value)}
                  />
                  {storeNameError && (
                    <p className="mt-1 text-xs text-red-500">
                      {storeNameError}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-primary mb-2">
                    Delivery Price <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <span className="text-gray-500">$</span>
                    </div>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      placeholder="0.00"
                      className={`w-full pl-8 px-4 py-3 rounded-md border ${
                        deliveryPriceError
                          ? "border-red-500 bg-red-50"
                          : "border-primary/20"
                      } focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm`}
                      value={deliveryPrice}
                      onChange={(e) => setDeliveryPrice(e.target.value)}
                    />
                  </div>
                  {deliveryPriceError && (
                    <p className="mt-1 text-xs text-red-500">
                      {deliveryPriceError}
                    </p>
                  )}
                  <p className="mt-1 text-xs text-primary/60">
                    Set the delivery fee for this store
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-primary mb-2">
                    Store Type <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <select
                      className={`w-full px-4 py-3 rounded-md border appearance-none bg-white pr-10 ${
                        storeTypeError
                          ? "border-red-500 bg-red-50"
                          : "border-primary/20"
                      } focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm`}
                      value={storeType}
                      onChange={(e) => setStoreType(e.target.value)}
                    >
                      <option value="">Select store type</option>
                      <option value="RESTAURANT">Restaurant</option>
                      <option value="GROCERIES">Grocery Store</option>
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-primary/60">
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                      </svg>
                    </div>
                  </div>
                  {storeTypeError && (
                    <p className="mt-1 text-xs text-red-500">
                      {storeTypeError}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-primary mb-2">
                    Store Email <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    placeholder="Enter store email"
                    className={`w-full px-4 py-3 rounded-md border ${
                      storeEmailError
                        ? "border-red-500 bg-red-50"
                        : "border-primary/20"
                    } focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm`}
                    value={storeEmail}
                    onChange={(e) => setStoreEmail(e.target.value)}
                  />
                  {storeEmailError && (
                    <p className="mt-1 text-xs text-red-500">
                      {storeEmailError}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-primary mb-2">
                    Store Phone <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter store phone number"
                    className={`w-full px-4 py-3 rounded-md border ${
                      storePhoneError
                        ? "border-red-500 bg-red-50"
                        : "border-primary/20"
                    } focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm`}
                    value={storePhone}
                    onChange={(e) => setStorePhone(e.target.value)}
                  />
                  {storePhoneError && (
                    <p className="mt-1 text-xs text-red-500">
                      {storePhoneError}
                    </p>
                  )}
                </div>
              </div>

              {/*  */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-primary mb-2">
                  Store Description <span className="text-red-500">*</span>
                </label>
                <textarea
                  placeholder="Enter store description"
                  className={`w-full px-4 py-3 rounded-md border ${
                    storeDescriptionError
                      ? "border-red-500 bg-red-50"
                      : "border-primary/20"
                  } focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm`}
                  rows={4}
                  value={storeDescription}
                  onChange={(e) => setStoreDescription(e.target.value)}
                ></textarea>
                {storeDescriptionError && (
                  <p className="mt-1 text-xs text-red-500">
                    {storeDescriptionError}
                  </p>
                )}
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-primary mb-2">
                    Store Logo <span className="text-red-500">*</span>
                  </label>
                  <div
                    className={`border-2 border-dashed rounded-lg p-4 ${
                      storeLogoError
                        ? "border-red-500 bg-red-50"
                        : "border-primary/20 hover:border-primary"
                    } transition-colors cursor-pointer`}
                  >
                    <input
                      type="file"
                      className="hidden"
                      id="store-logo"
                      accept="image/*"
                      value={storeLogoValue}
                      onChange={(e) => {
                        setStoreLogoValue(e.target.value);
                        setStoreLogo(e.target.files[0]);
                      }}
                    />
                    <label
                      htmlFor="store-logo"
                      className="flex flex-col items-center justify-center cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-10 w-10 text-primary/40 mb-2"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      <p className="text-sm text-primary/70">
                        Click to upload logo
                      </p>
                      <p className="text-xs text-primary/50 mt-1">
                        PNG, JPG up to 2MB
                      </p>
                      {storeLogoValue && (
                        <p className="text-xs text-primary mt-2 font-medium">
                          {storeLogoValue.split("\\").pop()}
                        </p>
                      )}
                    </label>
                  </div>
                  {storeLogoError && (
                    <p className="mt-1 text-xs text-red-500">
                      {storeLogoError}
                    </p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-primary mb-2">
                    Store Cover <span className="text-red-500">*</span>
                  </label>
                  <div
                    className={`border-2 border-dashed rounded-lg p-4 ${
                      storeCoverError
                        ? "border-red-500 bg-red-50"
                        : "border-primary/20 hover:border-primary"
                    } transition-colors cursor-pointer`}
                  >
                    <input
                      type="file"
                      className="hidden"
                      id="store-cover"
                      accept="image/*"
                      value={storeCoverValue}
                      onChange={(e) => {
                        setStoreCoverValue(e.target.value);
                        setStoreCover(e.target.files[0]);
                      }}
                    />
                    <label
                      htmlFor="store-cover"
                      className="flex flex-col items-center justify-center cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-10 w-10 text-primary/40 mb-2"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                      <p className="text-sm text-primary/70">
                        Click to upload cover image
                      </p>
                      <p className="text-xs text-primary/50 mt-1">
                        PNG, JPG up to 5MB
                      </p>
                      {storeCoverValue && (
                        <p className="text-xs text-primary mt-2 font-medium">
                          {storeCoverValue.split("\\").pop()}
                        </p>
                      )}
                    </label>
                  </div>
                  {storeCoverError && (
                    <p className="mt-1 text-xs text-red-500">
                      {storeCoverError}
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Store Location Section */}
            <div className="mb-8">
              <h3 className="text-lg font-medium text-primary mb-6">
                Store Location
              </h3>
              <div className="mb-6">
                <label className="block text-sm font-medium text-primary mb-2">
                  Store Address <span className="text-red-500">*</span>
                </label>
                <div className="mb-4">
                  <input
                    type="text"
                    disabled
                    placeholder="Selected address will appear here"
                    className={`w-full px-4 py-3 rounded-md border ${
                      storeAddressError
                        ? "border-red-500 bg-red-50"
                        : "border-primary/20"
                    } bg-primary/5 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm mb-2`}
                    value={storeAddress}
                    readOnly
                  />

                  <div className="p-4 border border-primary/20 rounded-lg">
                    <GooglePlacesAutocomplete
                      apiKey={API_MAP_KEY}
                      libraries={["places"]}
                      options={PLACES_AUTOCOMPLETE_OPTIONS}
                      onPlaceSelected={(place) => {
                        if (place.geometry) {
                          setStoreAddress(place.formatted_address);
                          setLocationX(place.geometry.location.lat());
                          setLocationY(place.geometry.location.lng());
                        }
                      }}
                      onKeyDown={async (event) => {
                        if (event.key !== "Enter") return;
                        event.preventDefault();
                        const result = await geocodeAddress(event.target.value);
                        if (
                          !applyGeocodedPlace(
                            result,
                            setStoreAddress,
                            setLocationX,
                            setLocationY
                          )
                        ) {
                          toast.error("Address not found. Try another search.");
                        }
                      }}
                      placeholder="Search or paste full address"
                      language="en"
                      className="w-full px-4 py-3 rounded-md border border-primary/20 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm"
                    />

                    <div className="mt-2 flex justify-end">
                      <button
                        type="button"
                        className="text-xs text-primary hover:text-primary-dark transition-colors"
                        onClick={async (event) => {
                          const input =
                            event.currentTarget.parentElement?.previousElementSibling;
                          const result = await geocodeAddress(input?.value);
                          if (
                            applyGeocodedPlace(
                              result,
                              setStoreAddress,
                              setLocationX,
                              setLocationY
                            )
                          ) {
                            if (input) input.value = result.formatted_address;
                          } else {
                            toast.error("Address not found. Try another search.");
                          }
                        }}
                      >
                        Find pasted address
                      </button>
                    </div>

                    <div className="mt-3 flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
                      <button
                        type="button"
                        className="text-sm text-primary hover:text-primary-dark transition-colors flex items-center"
                        onClick={() => {
                          setManualAddress("");
                          setManualLat(locationX || 0);
                          setManualLng(locationY || 0);
                          setShowManualModal(true);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 mr-1"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                          />
                        </svg>
                        Enter address manually
                      </button>

                      <div className="text-xs text-primary/60">
                        Search or click the button to enter manually
                      </div>
                    </div>
                  </div>

                  {storeAddressError && (
                    <p className="mt-1 text-xs text-red-500">
                      {storeAddressError}
                    </p>
                  )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-primary mb-2">
                      Latitude <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      disabled
                      placeholder="Latitude"
                      className="w-full px-4 py-3 rounded-md border border-primary/20 bg-primary/5 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm"
                      value={locationX}
                      readOnly
                    />
                    {locationXError && (
                      <p className="mt-1 text-xs text-red-500">
                        {locationXError}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-primary mb-2">
                      Longitude <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      disabled
                      placeholder="Longitude"
                      className="w-full px-4 py-3 rounded-md border border-primary/20 bg-primary/5 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm"
                      value={locationY}
                      readOnly
                    />
                    {locationYError && (
                      <p className="mt-1 text-xs text-red-500">
                        {locationYError}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Submit Buttons */}
            <div className="flex flex-col-reverse sm:flex-row justify-end gap-4 sm:space-x-4 pt-6 border-t border-primary/10">
              <a
                href="/stores"
                className="px-6 py-3 border border-primary/20 rounded-lg text-primary font-medium hover:bg-primary/5 transition-colors duration-200 text-center"
              >
                Cancel
              </a>
              <button
                onClick={async () => {
                  var check = true;
                  // Reset all error messages
                  setStoreNameError("");
                  setStoreLogoError("");
                  setStoreCoverError("");
                  setStoreTypeError("");
                  setStoreDescriptionError("");
                  setStoreTimeError("");
                  setEmailError("");
                  setPhoneError("");
                  setFirstNameError("");
                  setLastNameError("");
                  setPasswordError("");
                  setPasswordConfirmError("");
                  setSelectUserError("");
                  setStoreEmailError("");
                  setStorePhoneError("");
                  setStoreAddressError("");
                  setLocationXError("");
                  setLocationYError("");
                  setDeliveryPriceError("");

                  // Validate based on user type
                  if (userType === "Exist") {
                    if (selectUser === "") {
                      setSelectUserError("Please select a user");
                      check = false;
                    }
                  } else if (userType === "New User") {
                    if (firstName === "") {
                      setFirstNameError("First name is required");
                      check = false;
                    }
                    if (email === "") {
                      setEmailError("Email is required");
                      check = false;
                    }
                    if (phone === "") {
                      setPhoneError("Phone number is required");
                      check = false;
                    }

                    if (password === "") {
                      setPasswordError("Password is required");
                      check = false;
                    } else if (password !== passwordConfirm) {
                      setPasswordError("Passwords do not match");
                      setPasswordConfirmError("Passwords do not match");
                      check = false;
                    }
                  }
                  // Validate store information
                  if (storeName === "") {
                    setStoreNameError("Store name is required");
                    check = false;
                  }
                  if (storeType === "") {
                    setStoreTypeError("Store type is required");
                    check = false;
                  }
                  if (storeEmail === "") {
                    setStoreEmailError("Store email is required");
                    check = false;
                  }
                  if (storePhone === "") {
                    setStorePhoneError("Store phone is required");
                    check = false;
                  }
                  // if (!storeLogoValue) {
                  //   setStoreLogoError("Store logo is required");
                  //   check = false;
                  // }
                  // if (!storeCoverValue) {
                  //   setStoreCoverError("Store cover image is required");
                  //   check = false;
                  // }
                  if (storeDescription === "") {
                    setStoreDescriptionError("Store description is required");
                    check = false;
                  }
                  if (storeAddress === "") {
                    setStoreAddressError("Store address is required");
                    check = false;
                  }
                  if (locationX === 0 || locationX === "") {
                    setLocationXError("Location coordinates are required");
                    check = false;
                  }
                  if (locationY === 0 || locationY === "") {
                    setLocationYError("Location coordinates are required");
                    check = false;
                  }

                  if (deliveryPrice === "") {
                    setDeliveryPriceError("Delivery price is required");
                    check = false;
                  }

                  if (check) {
                    let full_name = firstName;
                    if (lastName !== "") {
                      full_name += " " + lastName;
                    }
                    await dispatch(
                      updateStore(id, {
                        user_type: userType,
                        user_select: userType === "Exist" ? selectUser : "",
                        store_name: storeName,
                        store_logo: storeLogo,
                        store_cover: storeCover,
                        store_type: storeType,
                        store_description: storeDescription,
                        store_address: storeAddress,
                        location_x: locationX,
                        location_y: locationY,
                        store_phone: storePhone,
                        store_email: storeEmail,
                        // create user
                        user_email: userType === "New User" ? email : "",
                        user_phone: userType === "New User" ? phone : "",
                        user_first_name:
                          userType === "New User" ? firstName : "",
                        user_last_name: userType === "New User" ? lastName : "",
                        user_full_name:
                          userType === "New User" ? full_name : "",
                        user_password: userType === "New User" ? password : "",
                        delivery_price: deliveryPrice,
                      })
                    );
                  } else {
                    toast.error("Please fill in all required fields");
                  }
                }}
                className="px-6 py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary-dark transition-colors duration-200 flex items-center justify-center w-full sm:w-auto"
                disabled={loadingStoreUpdate}
              >
                {loadingStoreUpdate ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Update Store...
                  </>
                ) : (
                  <>

                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="mr-2 h-5 w-5">
  <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
</svg>

                    Update Store
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
         {/* Manual Address Entry Modal */}
                {showManualModal && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-9999 p-0 sm:p-4 overflow-y-auto">
                    <div className="bg-white rounded-none sm:rounded-xl shadow-xl max-w-2xl w-full h-full sm:h-auto overflow-hidden sm:my-8">
                      <div className="px-4 sm:px-6 py-4 sm:py-5 border-b border-primary/10 flex justify-between items-center sticky top-0 bg-white z-10 shadow-sm">
                        <h2 className="text-base sm:text-lg font-semibold text-primary truncate mr-2">
                          Enter Address Manually
                        </h2>
                        <button
                          onClick={() => setShowManualModal(false)}
                          className="text-primary/40 hover:text-primary/70 transition-colors p-2 rounded-full flex-shrink-0"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>

                      <div className="p-4 sm:p-6 overflow-y-auto h-[calc(100vh-60px)] sm:max-h-[calc(100vh-120px)]">
                        <div className="mb-6">
                          <label className="block text-sm font-medium text-primary mb-2">
                            Address <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            className="w-full px-4 py-3 rounded-md border border-primary/20 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm"
                            value={manualAddress}
                            onChange={(e) => setManualAddress(e.target.value)}
                            placeholder="Enter full address"
                          />
                          {manualAddressError && (
                            <p className="mt-1 text-xs text-red-500">
                              {manualAddressError}
                            </p>
                          )}
                          <p className="mt-1 text-xs text-primary/60">
                            Enter the complete address including street, city, state,
                            and zip code
                          </p>
                        </div>

                        <div className="mb-6">
                          <label className="block text-sm font-medium text-primary mb-2">
                            Map Location{" "}
                            <span className="text-xs text-primary/60 ml-2">
                              (Click to set location)
                            </span>
                          </label>
                          <div className="h-48 sm:h-64 rounded-lg overflow-hidden border border-primary/20">
                            <MapContainer
                              center={[manualLat || 0, manualLng || 0]}
                              zoom={15}
                              style={{ height: "100%", width: "100%" }}
                              scrollWheelZoom={false}
                              dragging={true}
                            >
                              <TileLayer
                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                              />
                              <ClickableMap
                                manualLat={manualLat}
                                manualLng={manualLng}
                                setManualLat={setManualLat}
                                setManualLng={setManualLng}
                              />
                            </MapContainer>
                          </div>
                          <p className="mt-1 text-xs text-primary/60">
                            Click on the map to set the exact location
                          </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                          <div>
                            <label className="block text-sm font-medium text-primary mb-2">
                              Latitude <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              step="any"
                              className="w-full px-4 py-3 rounded-md border border-primary/20 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm"
                              value={manualLat}
                              onChange={(e) => setManualLat(parseFloat(e.target.value))}
                              placeholder="e.g. 40.7128"
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-medium text-primary mb-2">
                              Longitude <span className="text-red-500">*</span>
                            </label>
                            <input
                              type="number"
                              step="any"
                              className="w-full px-4 py-3 rounded-md border border-primary/20 focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary shadow-sm"
                              value={manualLng}
                              onChange={(e) => setManualLng(parseFloat(e.target.value))}
                              placeholder="e.g. -74.0060"
                            />
                          </div>
                        </div>

                        <div className="flex flex-col-reverse sm:flex-row justify-end gap-4 sm:space-x-4 pt-4 border-t border-primary/10">
                          <button
                            className="px-5 py-2.5 border border-primary/20 rounded-lg text-primary font-medium hover:bg-primary/5 transition-colors duration-200 w-full sm:w-auto"
                            onClick={() => setShowManualModal(false)}
                          >
                            Cancel
                          </button>
                          <button
                            className="px-5 py-2.5 bg-primary text-white rounded-lg font-medium hover:bg-primary-dark transition-colors duration-200 flex items-center justify-center w-full sm:w-auto"
                            onClick={() => {
                              setManualAddressError("");
                              if (manualAddress === "") {
                                toast.error("Please enter store address");
                                setManualAddressError("Address is required");
                              } else {
                                setStoreAddress(manualAddress);
                                setLocationX(manualLat);
                                setLocationY(manualLng);
                                setShowManualModal(false);
                              }
                            }}
                          >
                            <svg
                              className="mr-2 h-5 w-5"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                            Save Location
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
      </div>
    </DefaultLayout>
  );
}

export default EditStoreScreen;
